import { Alert, AlertTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';
import { ContentWrapper } from '../../components/content-wrapper';
import { useLabelsDesktopViewport } from '../../pages/prepackaged-labels/responsive-policy';

export function LabelsDesktopOnlyGuard() {
  const { t } = useTranslation('prepackagedLabel');
  const isDesktop = useLabelsDesktopViewport();

  if (isDesktop) {
    return <Outlet />;
  }

  return (
    <ContentWrapper>
      <Alert severity="info">
        <AlertTitle>{t('central.desktopOnly.title')}</AlertTitle>
        {t('central.desktopOnly.description')}
      </Alert>
    </ContentWrapper>
  );
}
